export default "__VITE_ASSET__180eadee__"